import React, { useEffect, useState } from "react";
import { Button, Spin } from "antd";
import { useLocation } from "react-router-dom";
import App from "./App";
import PublicWebsite from "../PublicWebsite/PublicWebsite";
import { getPublicWebsite } from "../../network/network";
import { getTenantSlug } from "../../network/tenant";

const WebsiteEntryState = ({ loading = false, onRetry }) => (
  <main
    style={{
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      gap: 16,
      justifyContent: "center",
      minHeight: "100vh",
      padding: 24,
      textAlign: "center",
    }}
  >
    {loading ? (
      <Spin size="large" />
    ) : (
      <>
        <h1 style={{ margin: 0 }}>Unable to load website</h1>
        <p style={{ margin: 0 }}>
          Please check your connection and try again.
        </p>
        <Button type="primary" onClick={onRetry}>
          Retry
        </Button>
      </>
    )}
  </main>
);

export const WebsiteRoot = ({ subdomain }) => {
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({
    status: "loading",
    data: null,
  });

  useEffect(() => {
    const controller = new AbortController();
    let isMounted = true;

    setState({ status: "loading", data: null });

    getPublicWebsite(subdomain, { signal: controller.signal })
      .then((response) => {
        if (!isMounted) return;

        const data = response?.data?.data;
        if (!data) {
          setState({ status: "error", data: null });
          return;
        }

        setState({ status: "ready", data });
      })
      .catch((error) => {
        if (!isMounted || controller.signal.aborted) return;

        const status = error?.response?.status;
        if (status === 403 || status === 404) {
          setState({ status: "portal", data: null });
          return;
        }

        setState({ status: "error", data: null });
      });

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [attempt, subdomain]);

  if (state.status === "portal") return <App />;
  if (state.status === "ready") return <PublicWebsite data={state.data} />;
  if (state.status === "error") {
    return <WebsiteEntryState onRetry={() => setAttempt((value) => value + 1)} />;
  }

  return <WebsiteEntryState loading />;
};

const WebsiteEntry = () => {
  const location = useLocation();
  const subdomain = getTenantSlug();

  if (location.pathname !== "/" || subdomain === null) {
    return <App />;
  }

  return <WebsiteRoot subdomain={subdomain} />;
};

export default WebsiteEntry;
